import React, { useEffect, useState, useContext } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory, Link } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
// import socket from '../componentes/Socket';
import Menu from "../componentes/Menu";

// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";

const PasantiasDetalle = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  const [titulo, setTitulo] = useState();
  const [empresa, setEmpresa] = useState();
  const [area, setArea] = useState();
  const [descripcion, setDescripcion] = useState({});
  // const [fechaInicio, setFechaInicio] = useState({});
  // const [fechaFin, setFechaFin] = useState({});
  // const [carrera, setCarrera] = useState({});
  // const [anio, setAnio] = useState({});
  // const [urlOldIMG, setUrlOldIMG] = useState({});

  const [modalidad, setModalidad] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [remuneracion, setRemuneracion] = useState("");
  const [aplicaciones, setAplicaciones] = useState(0);
  const [seleccionado, setSeleccionado] = useState(0);

  // const [file, setFile] = useState({});

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;
    dataUser.email = cred.correo;
  } else {
    history.push("/");
  }

  // let formatFecha = (fecha) => {
  //   let preFecha = new Date(fecha);
  //   let fechaPre = preFecha.toLocaleString().substr(0, 10).split("/");
  //   const es = navigator.userAgent.indexOf("Edg/") > -1;
  //   if (es) {
  //     // Si el navegado es Edge
  //     return fechaPre[2].substr(0, 4) + "-" + fechaPre[1] + "-" + fechaPre[0];
  //   } else {
  //     if (fechaPre[1] < 10) {
  //       fechaPre[1] = "0" + fechaPre[1];
  //     }
  //     if (fechaPre[0] < 10) {
  //       fechaPre[0] = "0" + fechaPre[0];
  //     }
  //     return (
  //       fechaPre[2].substr(0, 4) +
  //       "-" +
  //       fechaPre[1].substr(-0, 2) +
  //       "-" +
  //       fechaPre[0].substr(-0, 2)
  //     );
  //   }
  // };

  const query = new URLSearchParams(window.location.search);

  useEffect(() => {
    let dataUpdate = () => {
      let ryequ = new URLSearchParams(window.location.search);
      if (ryequ.get("id_pasantia")) {
        GetFetch.getPasantiaID(ryequ.get("id_pasantia"), dataUser.token).then(
          (pasantiaData) => {
            setTitulo(pasantiaData[0].titulo);
            setEmpresa(pasantiaData[0].empresa);
            setArea(pasantiaData[0].area);
            setDescripcion(pasantiaData[0].descripcion);
            // setFechaInicio(formatFecha(pasantiaData[0].fecha_inicio));
            // setFechaFin(formatFecha(pasantiaData[0].fecha_fin));
            prePhotoupdate(pasantiaData[0].imagen);
            // setUrlOldIMG(pasantiaData[0].imagen);
            // setCarrera(pasantiaData[0].carrera);
            // setAnio(pasantiaData[0].anio);
            setModalidad(pasantiaData[0].modalidad);
            setTiempo(pasantiaData[0].tiempo);
            setRemuneracion(pasantiaData[0].remuneracion);
            //Buscar si alumno ha aplicado a pasantia
            let dataPasantiaApply = pasantiaData[0].aplicaciones;
            // console.log(dataPasantiaApply);
            dataPasantiaApply.map(elemt => {
             elemt.carnet === dataUser.carnet && setAplicaciones(1);
             return null;
            });
            dataPasantiaApply.map(elemt => {
              if(elemt.carnet === dataUser.carnet){
                 +elemt.seleccionado === 1 ? setSeleccionado(1) : setSeleccionado(0);
              }
              return 0;
            });
            // setAplicaciones();
          }
        );
      }
    };

    dataUpdate();
    loadMenu();
  }, [dataUser]);

  // let prePhoto = (e) => {
  //   let imgDiv = document.getElementById("loadImagen"); //Elemento donde se carga la img vista previa
  //   let TmpPath = URL.createObjectURL(e.target.files[0]);
  //   imgDiv.innerHTML = `<img src="${TmpPath}" style='width: 45%' />`;
  // };

  let prePhotoupdate = (url) => {
    let imgDiv = document.getElementById("loadImagen"); //Elemento donde se carga la img vista previa
    let TmpPath = url;
    imgDiv.innerHTML = `<img src="${TmpPath}" style='width: 45%' />`;
  };

  // let onSutmit = async (e) => {
  //   e.preventDefault();
  // };

  const pasantiaBody = (descripcion) => {
    return { __html: descripcion };
  };

  const fechaHoraActual = () => {
    const tiempoTranscurrido = Date.now();
    const hoy = new Date(tiempoTranscurrido);
    return hoy.toISOString();
  };

  let applyPasantia = async (e) => {
    e.preventDefault();
    let dataApply = {
      carnet: dataUser.carnet,
      nombre: dataUser.nombre,
      correo: dataUser.email,
      fecha: fechaHoraActual(),
      seleccionado: 0,
      stado: 0
    };
    const data = new FormData();
    data.append("secret", "5ec4702eff406849a82818cb");
    data.append("aplicaciones", JSON.stringify(dataApply));
    data.append("_id", query.get("id_pasantia"));
    //Registrando aplicación de pasantia
    let setRegis = await GetFetch.setApplyPasantia(data, dataUser.token).then(
      (datosSet) => {
        if (datosSet.success) {
          return datosSet.success;
        } else {
          return 0;
        }
      }
    );
    if (+setRegis === 1) {
      setAplicaciones(1);
    }
  };

  let removeApplyPasantia = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("secret", "5ec4702eff406849a82818cb");
    data.append("carnet", dataUser.carnet);
    data.append("_id", query.get("id_pasantia"));
    //Eliminando aplicación de pasantia
    let setRegis = await GetFetch.removeApplyPasantia(data, dataUser.token).then(
      (datosSet) => {
        if (datosSet.success) {
          return datosSet.success;
        } else {
          return 0;
        }
      }
    );
    if (+setRegis === 1) {
      setAplicaciones(0);
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <div className="footer">
            <p>
              Copyright &copy;
              {/* <script>
                                document.write(new Date().getFullYear());
                            </script> All rights reserved | This template is made with <i className="icon-heart" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib.com</a> */}
            </p>
          </div>
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Detalle de pasantía</h2>
        <div className="card mb-3">
          <div className="card-body">
            <div className="d-flex align-items-start justify-content-between mb-3">
              <h5 className="card-title mb-0">{titulo}</h5>
              {+seleccionado === 1 ? (
                <span className="esen-chip esen-chip--success ml-2">
                  <i className="fa fa-check mr-1" aria-hidden="true"></i> Seleccionado
                </span>
              ) : aplicaciones === 1 ? (
                <span className="esen-chip esen-chip--info ml-2">
                  <i className="fa fa-check-circle-o mr-1" aria-hidden="true"></i> Ya aplicaste
                </span>
              ) : null}
            </div>
            <div
              className="card-text mb-3"
              dangerouslySetInnerHTML={pasantiaBody(descripcion)}
            ></div>
            <div className="table-responsive">
              <table className="table mb-3">
                <tbody>
                  <tr>
                    <th scope="row">Área</th>
                    <td>{area}</td>
                  </tr>
                  <tr>
                    <th scope="row">Empresa</th>
                    <td>{empresa}</td>
                  </tr>
                  <tr>
                    <th scope="row">Modalidad</th>
                    <td>{modalidad}</td>
                  </tr>
                  <tr>
                    <th scope="row">Remuneración</th>
                    <td>${remuneracion}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tiempo</th>
                    <td>{tiempo}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div id="loadImagen" className="mt-1 text-center"></div>

            {+seleccionado === 1 ? (
              <div className="alert alert-success mt-4 text-center" role="alert">
                <i className="fa fa-thumbs-o-up mr-2" aria-hidden="true"></i>
                <b>¡Felicidades!</b> Fuiste seleccionado para esta pasantía.
              </div>
            ) : aplicaciones === 0 ? (
              <div className="form-group mt-4 mb-0">
                <input
                  type="submit"
                  className="btn btn-primary btn-block"
                  value="Aplicar a pasantía"
                  onClick={applyPasantia}
                />
              </div>
            ) : (
              <div className="form-group mt-4 mb-0">
                <input
                  type="submit"
                  className="btn btn-outline-primary btn-block"
                  value="Cancelar aplicación"
                  onClick={removeApplyPasantia}
                />
              </div>
            )}
          </div>
        </div>
        <Link
          to={"pasantiasalumnos"}
          className="btn btn-outline-primary btn-sm mb-3"
        >
          <i className="fa fa-arrow-left mr-1" aria-hidden="true"></i> Volver a pasantías
        </Link>
      </div>
    </div>
  );
};

export default PasantiasDetalle;
